import BaseApiRequest from "./BaseApiRequest";
import { UPDATE_APPLICATION_ID_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class DeleteApplicationRequest extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  body = {};

  url = UPDATE_APPLICATION_ID_URL;

  constructor(id) {
    super();
    this.url = this.url.concat(id);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
